import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import VerticalNavigator from "@/layouts/vertical_navigator.vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("h1", null, " RutSolve ", -1),
          _createElementVNode("p", null, [
            _createTextVNode(" This application is still under construction, "),
            _createElementVNode("br"),
            _createTextVNode(" but expect things to come! ")
          ], -1),
          _createElementVNode("p", null, [
            _createTextVNode(" RutSolve will help entrepreneurs with tedious administrative tasks, "),
            _createElementVNode("br"),
            _createTextVNode(" like creating orders, invoices, offers and more! ")
          ], -1)
        ]))]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})